import React, { Component } from 'react'

export class Nosotros_Quienes extends Component {
    render() {
        return (
            <div style={{padding: '3% 6%'}} >
                <h3 className="inicio-title">Quienes somos</h3>
                
                <p>
                    Somos la ART de la Unión Argentina de Trabajadores Rurales y Estibadores (UATRE), orientada a brindar cobertura y prevención de accidentes laborales a los productores rurales y sus trabajadores.<br/>
                </p>
                
                <p>
                    En ART Mutual Rural tenemos como objetivo contribuir al cuidado integral de la salud de quienes trabajan en el ámbito rural y, al mismo tiempo, facilitar la misión de los empresarios productores. <br/>
                </p>

                <p>
                    Nuestros clientes tienen en nosotros un aliado confiable en los programas de capacitación y prevención permanentes, que conducirán a una producción más eficiente, redundando en un beneficio mayor para todos los involucrados en el proceso productivo.<br/>
                </p>
               
                <p>
                    Damos cobertura ante accidentes de trabajo y enfermedades laborales a los que día a día producen, acondicionan y procesan los alimentos que brinda nuestra tierra, que consumen 44 millones de argentinos y cerca de 400 millones de personas en todo el mundo.<br/>
                </p>
            </div>
        )
    }
}

export default Nosotros_Quienes
